import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { CsrListComponent } from '../csr-list/csr-list.component';
import { CsrRejectComponent } from '../csr-reject/csr-reject.component';
interface incubDis {
  district: string;
}
@Component({
  selector: 'app-csr-add',
  templateUrl: './csr-add.component.html',
  styleUrls: ['./csr-add.component.css'],
})
export class CsrAddComponent implements OnInit {
  csruploadForm: FormGroup;
  private getApi = environment.url + environment.csrProjectGet;
  private csrupdate = environment.url + environment.csrApproval;
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected incubatorDistrictList: incubDis[] = [];
  taluks: any;
  proFile: any;
  datas;
  savelbl = 'Save';
  RegFileNameValue: any;
  actiondocumentUrl: any;
  projectView;
  /**
   * CsrAddComponent constructor.
   * @param httpClient The HttpClient injected using dependency injection.
   * @param data The data passed from the parent component.
   * @param fb The FormBuilder injected using dependency injection.
   * @param makeapi The ApiService injected using dependency injection.
   * @param getdata The ValueService injected using dependency injection.
   * @param notify The NotifyService injected using dependency injection.
   * @param dialog The MatDialog injected using dependency injection.
   * @param dialogRef The MatDialogRef injected using dependency injection.
   */
  constructor(
    private httpClient: HttpClient,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CsrListComponent>
  ) {
    this.datas = data;

    /**
     * If the data is from the update button, set the save button label to 'Update' and
     * fetch the event details from the database.
     */
    if (data.title == 'Update') {
      this.savelbl = 'Update';
      this.getEventDetails(data._id);
    }

    /**
     * Create a form group for the CSR upload form.
     */
    this.csruploadForm = this.fb.group({
      /**
       * The unique identifier for the CSR project.
       */
      id: ['0'],

      /**
       * The name of the organization.
       */
      organizationName: ['', [Validators.required]],

      /**
       * The year in which the project was completed.
       */
      inCropYear: ['', [Validators.required]],

      /**
       * The registration number for the project.
       */
      dropRegNo: ['', [Validators.required]],

      /**
       * The address of the project.
       */
      regAddr: ['', [Validators.required]],

      /**
       * The mobile number of the project contact person.
       */
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],

      /**
       * The name of the project contact person.
       */
      spocName: ['', [Validators.required]],

      /**
       * The email address of the project contact person.
       */
      spocEmail: ['', [Validators.required, Validators.email]],

      /**
       * The mobile number of the project contact person.
       */
      spocMobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],

      /**
       * The name of the project.
       */
      name: ['', [Validators.required]],

      /**
       * The email address for the project.
       */
      email: ['', [Validators.required, Validators.email]],

      /**
       * The sector in which the project is undertaken.
       */
      projectSector: ['', [Validators.required]],

      /**
       * The districts in which the project is undertaken.
       */
      districts: [[], [Validators.required]],

      /**
       * The taluks in which the project is undertaken.
       */
      taluks: ['', [Validators.required]],

      /**
       * The year in which the project was completed.
       */
      completionYear: ['', [Validators.required]],

      /**
       * The budget for the project.
       */
      budget: ['', [Validators.required]],

      /**
       * The outcome of the project.
       */
      projectOutCome: ['', [Validators.required]],

      /**
       * The documents for the incorporation certificate.
       */
      incorpCertifDocuments: ['', [Validators.required]],

      /**
       * The documents for the 12A certificate.
       */
      twlaa80gDocuments: ['', [Validators.required]],

      /**
       * The documents for the action plan.
       */
      actionPlanDocuments: ['', [Validators.required]],

      /**
       * The documents for the track record.
       */
      trackRecordDocuments: ['', [Validators.required]],

      /**
       * The other documents for the project.
       */
      otherDocuments: [''],
    });
    this.districtValues = ['Madurai', 'Chennai', 'Virudhunagar'];
  }
  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive
   * This is where we can put initialization code that depends on the input properties
   */
  ngOnInit(): void {
    // Fetch the list of taluks from the API
    this.taluks();
  }
  get add() {
    return this.csruploadForm.controls;
  }

  districtValues = [];
  stateValue = [];
  statevalues;
  /**
   * Load the list of states from the assets/json/Indian.json file.
   * This is a static file that contains the list of states in India.
   * @returns {void}
   */
  stateList(): void {
    /**
     * The API endpoint to fetch the list of states
     * @type {string}
     */
    const url: string = 'assets/json/Indian.json';

    /**
     * Fetch the list of states from the API endpoint
     * @returns {Observable<any>}
     */
    this.httpClient.get<any>(url).subscribe((data: any) => {
      /**
       * The list of states
       * @type {any[]}
       */
      this.stateValue = data;

      /**
       * The list of districts in the selected state
       * @type {any[]}
       */
      this.statevalues = this.stateValue[0].states;
    });
  }
  /**
   * Form data object to store form data
   */
  formData: any = {};

  /**
   * Close the dialog when cancel button is clicked
   */
  cancelEvent() {
    this.dialogRef.close();
  }
  selectedState: string = '';
  selectedCity: string = '';
  cities: any[] = [];
  /**
   * Select a state and update the list of cities.
   * @param state the selected state
   */
  onSelectState(state: string): void {
    // Update the selected state
    this.selectedState = state;

    // Find the selected state
    const selectedStateData = this.statevalues.find(
      (s) => s.stateName === this.selectedState
    );

    // Update the list of cities
    this.cities = selectedStateData.districts;

    // Clear the selected city
    this.selectedCity = '';
  }

  /**
   * Delete the uploaded incubator brochure.
   *
   * If the incubator has been established, call the API to delete the brochure.
   * Otherwise, simply clear the form fields.
   */
  deleteImage() {
    if (this.proFile.incubatorYearofEstd != null) {
      // Make API call to delete the brochure.
      this.makeapi.method(this.csruploadForm, '', 'get').subscribe((data) => {
        if (data.responseStatus === 'Success') {
          this.FileValue = '';
          this.FileName = '';
          this.disName = '';
          // Clear the form fields.
          const getform = this.csruploadForm.value;
          getform.incubatorBrouchureFile = '';
          getform.incubatorBrouchureName = '';
          this.csruploadForm.patchValue(getform);
          this.notify.notifysuccess(data.responseMessage);
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    } else {
      // Clear the form fields.
      this.FileValue = '';
      this.FileName = '';
      this.disName = '';
      this.notify.notifyError('Brouchure Removed Successfully');
    }
  }

  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  /**
   * Handles the file upload for the registration document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  fileRegUpload(event): void {
    this.selecetdRegFile = event.target.files[0];
    if (event.target.files && this.selecetdRegFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdRegFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Check if the file type is valid
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          this.urlReg = reader.result;
          const spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.RegFileName = this.selecetdRegFile.name;
          this.RegdisName = this.selecetdRegFile.name;
          const getform = this.csruploadForm.value;
          getform.incubatorRegFileName = this.selecetdRegFile.name;
          getform.incubatorRegFile = this.RegFileValue;
          this.csruploadForm.patchValue(getform);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }

  selecetdTwelFile: any = [];
  urlTwel: any;
  TwelFileValue: any = '';
  TwelFileName: any;
  TweldisName;
  /**
   * Handles the file upload for the 12AA and 80G certificate document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  twelldocfileUpload(event) {
    this.selecetdTwelFile = event.target.files[0];
    if (event.target.files && this.selecetdTwelFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdTwelFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      // Check if the file type is valid
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdTwelFile);
        reader.onload = () => {
          this.urlTwel = reader.result;
          let spl = this.urlTwel.split(',');
          this.TwelFileValue = spl[1];
          this.TwelFileName = this.selecetdTwelFile.name;
          this.TweldisName = this.selecetdTwelFile.name;
          let getform = this.csruploadForm.value;
          getform.twlaa80gDocuments = this.TwelFileValue;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // new Action part
  selecetdActionFile: any = [];
  urlAction: any;
  ActionFileValue: any = '';
  ActionFileName: any;
  ActiondisName;
  /**
   * Handles the file upload for the action plan document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  actiondocfileUpload(event) {
    this.selecetdActionFile = event.target.files[0];
    if (event.target.files && this.selecetdActionFile) {
      // Check if the file type is valid
      const imagetype = this.selecetdActionFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        const reader = new FileReader();
        reader.readAsDataURL(this.selecetdActionFile);
        reader.onload = () => {
          this.urlAction = reader.result;
          // Split the data URL into its parts
          const spl = this.urlAction.split(',');
          // Set the file value and name
          this.ActionFileValue = spl[1];
          this.ActionFileName = this.selecetdActionFile.name;
          this.ActiondisName = this.selecetdActionFile.name;
          // Update the form with the uploaded file
          const getform = this.csruploadForm.value;
          getform.actionPlanDocuments = this.ActionFileValue;
          this.csruploadForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // new Track Record
  selecetdTrackrecFile: any = [];
  urlTrackrec: any;
  TrackrecFileValue: any = '';
  TrackrecFileName: any;
  TrackrecdisName;
  /**
   * Handles the file upload for the track record document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  trackrecdocfileUpload(event) {
    this.selecetdTrackrecFile = event.target.files[0];
    if (event.target.files && this.selecetdTrackrecFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdTrackrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdTrackrecFile);
        reader.onload = () => {
          this.urlTrackrec = reader.result;
          let spl = this.urlTrackrec.split(',');
          this.TrackrecFileValue = spl[1];
          this.TrackrecFileName = this.selecetdTrackrecFile.name;
          this.TrackrecdisName = this.selecetdTrackrecFile.name;
          let getform = this.csruploadForm.value;
          getform.trackRecordDocuments = this.TrackrecFileValue;
          // Update the form with the uploaded file
          this.csruploadForm.patchValue(getform);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }

  //  Other Records document
  selecetdOtherrecFile: any = [];
  urlOtherrec: any;
  OtherrecFileValue: any = '';
  OtherrecFileName: any;
  OtherrecdisName;
  /**
   * Handles the file upload for the other records document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  otherrecdocfileUpload(event) {
    this.selecetdOtherrecFile = event.target.files[0];
    if (event.target.files && this.selecetdOtherrecFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdOtherrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdOtherrecFile);
        reader.onload = () => {
          this.urlOtherrec = reader.result;
          let spl = this.urlOtherrec.split(',');
          this.OtherrecFileValue = spl[1];
          this.OtherrecFileName = this.selecetdOtherrecFile.name;
          this.OtherrecdisName = this.selecetdOtherrecFile.name;
          let getform = this.csruploadForm.value;
          getform.otherDocuments = this.OtherrecFileValue;
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  incorpFileName: any;
  twlaaFileName: any;
  actionFileName: any;
  otherFileName: any;
  trackFileName: any;
  incorpFileValue: any;
  twlaaFileValue: any;
  trackFileValue: any;
  actionFileValue: any;
  otherFileValue: any;

  documentValues = [];
  disName;
  tweelName;
  getId;
  inCropYearValue: number;
  docName1;
  docName2;
  docName3;
  docName4;
  docName5;
  /**
   * Fetches the details of a CSR by ID and updates the form.
   * @param {ObjectId} id - The ID of the CSR to fetch.
   */
  getEventDetails(id) {
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'get')
      .subscribe((data) => {
        // Patch the form with the CSR details.
        this.csruploadForm.patchValue(data);

        // Store the CSR ID and details.
        this.getId = data;
        this.projectView = data;

        // Check if the CSR has a document for each type and update the form controls accordingly.
        if (
          data.incorpCertifDocuments != '' &&
          data.incorpCertifDocuments != undefined
        ) {
          // Update the incorporation certificate form control.
          this.incorpFileValue = data.incorpCertifDocuments.documentFile;
          this.incorpFileName = data.incorpCertifDocuments.documentName;
          this.docName1 = '✔ Uploaded';
        }

        if (
          data.twlaa80gDocuments != '' &&
          data.twlaa80gDocuments != undefined
        ) {
          // Update the 12AA and 80G form control.
          this.twlaaFileValue = data.twlaa80gDocuments.documentFile;
          this.twlaaFileName = data.twlaa80gDocuments.documentName;
          this.docName2 = '✔ Uploaded';
        }

        if (
          data.trackRecordDocuments != '' &&
          data.trackRecordDocuments != undefined
        ) {
          // Update the track record form control.
          this.trackFileValue = data.trackRecordDocuments.documentFile;
          this.trackFileName = data.trackRecordDocuments.documentName;
          this.docName4 = '✔ Uploaded';
        }

        if (
          data.actionPlanDocuments != '' &&
          data.actionPlanDocuments != undefined
        ) {
          // Update the action plan form control.
          this.actionFileValue = data.actionPlanDocuments.documentFile;
          this.actionFileName = data.actionPlanDocuments.documentName;
          this.docName3 = '✔ Uploaded';
        }

        if (data.otherDocuments != '' && data.otherDocuments != undefined) {
          // Update the other document form control.
          this.otherFileValue = data.otherDocuments.documentFile;
          this.otherFileName = data.otherDocuments.documentName;
          this.docName5 = '✔ Uploaded';
        }

        // Update the form control for the crop year.
        this.inCropYearValue = data.inCropYear;
      });
  }
  sam;
  /**
   * Updates the status of a CSR to approved.
   * @param {ObjectId} getId.id - The ID of the CSR to update.
   */
  ApprovedBtn(getId) {
    this.sam = getId.id;
    // Create a request object with the CSR ID and status to update.
    let req = {
      id: this.sam,
      status: 1,
    };
    return this.makeapi
      .method(this.csrupdate, req, 'post')
      .subscribe((data) => {
        // Display a success notification with the response message.
        this.notify.notifysuccess(data.responseMessage);
        // Close the current dialog.
        this.dialogRef.close();
        // Reload the page to update the data.
        window.location.reload();
      });
  }
  /**
   * Opens the reject form dialog for the given CSR ID.
   * After the dialog is closed, it will close the current dialog and
   * refresh the data in the parent component.
   * @param csruploadForm - The form data containing the CSR ID.
   */
  RejectBtn(csruploadForm) {
    let sam = csruploadForm.id;
    const dialogRef = this.dialog.open(CsrRejectComponent, {
      width: '390px',
      data: { _id: sam },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the data in the parent component after the dialog is closed.
      this.getdata.isVisibleSource.next(true);
    });

    // Close the current dialog after opening the reject form dialog.
    this.dialogRef.close();
  }
  /**
   * Opens the action document URL in a new tab if available.
   * Logs an error message to the console if the URL is not available.
   */
  inco() {
    if (this.actiondocumentUrl) {
      // Open the document URL in a new browser tab
      window.open(this.actiondocumentUrl, '_blank');
    } else {
      // Log an error message if the URL is not available
      console.error('Download URL is not available.');
    }
  }

  /**
   * Opens the incorporation document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  incorpDocu() {
    if (this.incorpFileName) {
      // Open the file URL in a new browser tab
      window.open(this.incorpFileName, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the action document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  actionDocu() {
    if (this.actionFileName) {
      // Open the file URL in a new browser tab
      window.open(this.actionFileName, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the Twlaa80g document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  twlaa80gDoc() {
    if (this.twlaaFileName) {
      // Open the file URL in a new browser tab
      window.open(this.twlaaFileName, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the track record document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  trackrecDoc() {
    if (this.trackFileName) {
      // Open the file URL in a new browser tab
      window.open(this.trackFileName, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the other document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  otherrecDoc() {
    if (this.otherFileName) {
      // Open the file URL in a new browser tab
      window.open(this.otherFileName, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
}
